/**
 * @desc 采购调价申请单提交
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ProcurementOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/submitOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
